import axios from 'axios';
import { API_BASE_URL } from '../config';
import { getAuthHeadersFromStorage } from '../utils/authHeaders';
import { attachAuthInterceptor } from '../utils/attachAuthInterceptor';

const client = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const authHeaders = getAuthHeadersFromStorage();
  if (Object.keys(authHeaders).length) {
    config.headers = { ...authHeaders, ...config.headers };
  }
  return config;
});
attachAuthInterceptor(client);

export const convertStepToGlb = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await client.post('/api/v1/cad/convert', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

